module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-face-feeling-2-svgrepo-com.e567336f.svg";